import React, { useContext } from 'react';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import Img from 'gatsby-image';
import Gallery from './Gallery';
import Collapsible from './Collapsible';
import LocaleBlock from './LocaleBlock';
import Vimeo from './Vimeo';
// import LocaleContext from './LocaleContext';
// import { tr } from '../utils/translations';

export default function GeneralPageSections({ page, pageContext }) {
  const sanityConfig = {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID,
    dataset: process.env.GATSBY_SANITY_DATASET,
  };
  // const isJournalPage = !!page.categories.length;
  // const [locale] = useContext(LocaleContext);

  return (
    <div className="sections">
      {page._rawSections.map((pageSection) => (
        <div
          className={`pageSection ${pageSection._type} ${pageSection.className}`}
          key={pageSection._key}
        >
          {/* Gallery section */}
          {pageSection._type === 'gallery' && (
            <div className="gallery" key={pageSection._key}>
              <Gallery
                imageMaxWidth={pageContext.imageMaxWidth}
                images={pageSection.images}
                className={pageSection.className}
              />
            </div>
          )}

          {/* Link button */}
          {pageSection._type === 'link' && (
            <div className="buttonWrapper" key={pageSection._key}>
              <a
                className={`button cta ${pageSection.className}`}
                href={pageSection.url}
              >
                {pageSection.text}
              </a>
            </div>
          )}

          {pageSection._type === 'pageSection' &&
            pageSection.content.map((section, index) => {
              // Image section
              if (section._type === 'imageWithAlt') {
                const fluidProps = getFluidGatsbyImage(
                  section.asset._ref,
                  { maxWidth: pageContext.imageMaxWidth },
                  sanityConfig
                );

                return (
                  <Img
                    data-sal="fade"
                    data-sal-duration="1500"
                    key={section._key}
                    fluid={fluidProps}
                    alt={section.alt}
                    className={section.className}
                  />
                );
              }

              // Vimeo section
              if (section._type === 'vimeo') {
                return (
                  <Vimeo
                    className="vimeo"
                    vimeoID={section.vimeoID}
                    heightRatio={section.heightRatio}
                    allowExpand
                  />
                );
              }

              // Collapsible section
              if (section._type === 'collapsible') {
                return (
                  <Collapsible
                    key={section._key}
                    title={section.name}
                    text={section.text}
                    className={section.className}
                    data-sal={page.className === 'faq' ? '' : 'fade'}
                    data-sal-duration="1500"
                    defaultCollapsed
                  />
                );
              }

              // Text section
              return (
                <LocaleBlock
                  content={section}
                  key={`${pageSection._key}_${index}`}
                />
              );
            })}
        </div>
      ))}
    </div>
  );
}
